module.exports = __webpack_public_path__ + "img/img-a60e2d68.2418a928.png";